import React from 'react'
import * as translationService from '../services/translationService'
import * as routeService from '../services/routeService'
import { Form, FormStepper, Button, ButtonGroup, PropertyBar } from './../components'
import ResidentsScene from './scenes/ResidentsScene'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { scroller } from 'react-scroll'

class ResidentsView extends React.PureComponent {
  static propTypes = {
    step: PropTypes.any,
    property: PropTypes.object,
  }
  state = {
    values: {
      people: { required: true, value: 1 },
      child: { required: true, value: 0 },
    },
  }

  residentsSceneRef = {}

  componentDidMount = () => {
    scroller.scrollTo('mainContent', {
      smooth: true,
    })
  }

  onChange = event => {
    const { target = {}, targets = {} } = event
    this.setState({
      values: {
        ...this.state.values,
        ...target,
        ...targets,
      },
    })
  }

  goToNextFlow = () => {
    this.residentsSceneRef
      .onSubmit()
      .then(() => {
        // routeService.goToRentIntentionPage()
        routeService.goToNextFlowPage(this.props.step)
      })
      .catch(() => {})
  }

  render() {
    const { property } = this.props
    return (
      <div>
        {property && <PropertyBar property={property} />}
        <FormStepper steps={routeService.getStepperRoutes(this.props.step, property && property.zip)} />
        <Form>
          <ResidentsScene onRef={ref => (this.residentsSceneRef = ref)} />
          <div>
            <ButtonGroup>
              <Button onClick={() => this.goToNextFlow()} primary>
                {translationService.buttonNext()}
              </Button>
            </ButtonGroup>
          </div>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = ({ FlowReducer }) => {
  const { step, property } = FlowReducer
  return {
    step,
    property,
  }
}

export default compose(connect(mapStateToProps))(ResidentsView)



// WEBPACK FOOTER //
// ./src/views/ResidentsView.js